import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import Button from 'components/Form/Button';
import ModalWrapper from 'components/ModalWrapper';
import Modal from 'components/Modal';
import AuthFeature from 'components/AuthFeature';
import { AUTH_READ_CUSTOMER_CARD_INFO } from 'constants/permission';
import { PAYMENT_CHANNEL_GOPOCKET } from 'constants/rental';
import { BINDING_CARD_FAILED } from 'constants/customer';
import Input, { TYPE_TEXT, TYPE_DATETIME } from 'components/Form/Input';
import Form from 'components/Form';
import CardBindingStatus from './CardBindingStatus';
import { useLazyGetCustomerCardInfoQuery } from 'redux/hook/useCustomer';
import { toggleErrorDialog } from 'actions';
import './binding-card-info.scss';

const DEFAULT_EMPTY_STRING = '--';

const BindingCardInfo = ({
    customerId,
    isValid,
}) => {
    const i18n = useSelector(state => state.i18n);
    const [getCustomerCardInfo] = useLazyGetCustomerCardInfoQuery();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);
    const [info, setInfo] = useState();

    const handleInfoOpen = async(e) => {
        setIsLoading(true);
        if (customerId) {

            const { data: infoData, error } = await getCustomerCardInfo({ id: customerId });
            if (error) {
                const { status, data } = error || {};
                const { code } = data || {};
                let msg = I18n.t('ticket.general_error_message');
                if (status === 409) {
                    msg = I18n.t(`customer.binding_card_error_${ code }`);
                }
                dispatch(toggleErrorDialog(msg));
            }
            else {
                setInfo(infoData);
                setIsShowModal(true);

            }
        }

    };

    const handleClose = e => {
        setIsShowModal(false);
        setIsLoading(false);
        setInfo({});
    };

    const getErrorMessage = () => {
        let stringCode = info.code || DEFAULT_EMPTY_STRING;
        let stringMsg = info.message || DEFAULT_EMPTY_STRING;

        if (info.bind_status === BINDING_CARD_FAILED) {
            if (info.payment_channel === PAYMENT_CHANNEL_GOPOCKET) {
                stringCode = DEFAULT_EMPTY_STRING;
                stringMsg = I18n.t('contact_go_wallet');
            }
            if (stringCode === DEFAULT_EMPTY_STRING && stringMsg === DEFAULT_EMPTY_STRING) {
                return DEFAULT_EMPTY_STRING;
            }
            return `(${stringCode}) ${stringMsg}`;
        }
        return ;

    };

    useEffect(() => { }, [i18n]);

    return (
        <AuthFeature requiredList={ [AUTH_READ_CUSTOMER_CARD_INFO] }>
            {
                isValid ? (
                    <Button
                        className="customer-card-info-btn"
                        type="button"
                        outline
                        onClick={ handleInfoOpen }
                        disable={ isLoading || !customerId }
                    >
                        <Translate value="more" />
                    </Button>
                ) : null
            }

            {
                isShowModal ? (
                    <ModalWrapper>
                        <Modal
                            className="customer-card-info-modal"
                            title={ I18n.t('customer.binding_card_info_title') }
                            onClose={ handleClose }
                        >
                            <Form tag="div" inline>
                                <CardBindingStatus status={ info.bind_status } />
                                <Input
                                    type={ TYPE_TEXT }
                                    caption="customer.binding_card_info_last_no"
                                    value={ info.credit_card_no }
                                    viewMode
                                />
                                <Input
                                    type={ TYPE_DATETIME }
                                    caption="customer.binding_card_time"
                                    value={ info.bind_time }
                                    viewMode
                                />
                                {
                                    info.bind_status === BINDING_CARD_FAILED ? (
                                        <Input
                                            type={ TYPE_TEXT }
                                            assignedstyle="bind-card-message"
                                            caption="customer.binding_card_fail_reason"
                                            value={ getErrorMessage() }
                                            viewMode
                                        />
                                    ): null
                                }
                            </Form>
                        </Modal>
                    </ModalWrapper>
                ) : null
            }
        </AuthFeature>
    );
};
BindingCardInfo.propTypes = {
    customerId: PropTypes.string,
    isValid: PropTypes.bool,
};

BindingCardInfo.defaultProps = {
    customerId: undefined,
    isValid: false,
};

export default BindingCardInfo;